import React from "react";

function GiftCardImage({ src }) {
  return (
    <div className="flex flex-col justify-start">
      <img
        className="mx-auto max-h-80 shadow-sm md:mx-0"
        src={src}
        alt="gift card"
      />
    </div>
  );
}

export default GiftCardImage;
